import {
    useMemo
} from "react";
import {
    NCoreUIKitTheme
} from "ncore-ui-kit";

type SvgTextStyle = {
    fontWeight: "300" | "400" | "500" | "600";
    fontFamily: string;
    fontSize: number;
};

export const useAnatomyStyle = () => {
    const {
        shapeConfigs,
        typography,
        radiuses,
        borders,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    return useMemo(() => {
        const getText = (variant: "labelSmallSize" | "bodySmallSize" | "monoMediumSize"): SvgTextStyle => ({
            fontWeight: typography[variant].fontWeight as SvgTextStyle["fontWeight"],
            fontFamily: typography[variant].fontFamily,
            fontSize: typography[variant].fontSize
        });

        const content = colors.content;

        return {
            dash: {
                bounds: `${spaces.spacingSm + spaces.spacingXxs} ${spaces.spacingXxs} ${spaces.spacingXxs} ${spaces.spacingXxs}`,
                center: `${spaces.spacingSm} ${spaces.spacingXxs} ${spaces.spacingXxs} ${spaces.spacingXxs}`,
                dotted: `${spaces.spacingXxs} ${spaces.spacingXs}`,
                ghost: `${spaces.spacingXs} ${spaces.spacingXs}`
            },
            color: {
                selected: content.container.selected,
                gridMajor: content.border.default,
                hover: content.container.subtle,
                inverse: content.text.onPrimary,
                stage: content.container.mid,
                faint: content.border.hover,
                grid: content.border.subtle,
                hatch: content.text.infoLow,
                accent: content.text.info,
                high: content.text.high,
                line: content.icon.low,
                ink: content.text.low,
                mid: content.text.mid
            },
            text: {
                label: getText("labelSmallSize"),
                small: getText("bodySmallSize")
            },
            width: {
                strong: borders.subtract,
                hit: spaces.spacingMd,
                halo: borders.halo,
                thin: borders.line
            },
            shapeConfigs,
            radiuses,
            spaces,
            borders
        };
    }, [
        shapeConfigs,
        typography,
        radiuses,
        borders,
        spaces,
        colors
    ]);
};

export type AnatomyStyle = ReturnType<typeof useAnatomyStyle>;
